import { useRef, useState } from "react";

function useCoolDown() {
  const [isCoolingDown, setIsCoolingDown] = useState(false);
  const timer = useRef<number | null>(null);
  return {
    cancel: () => {
      if (timer.current) {
        window.clearTimeout(timer.current);
        timer.current = null;
      }
    },
    coolDown: (durationMS: number) => {
      setIsCoolingDown(true);
      if (timer.current) {
        window.clearTimeout(timer.current);
      }
      timer.current = window.setTimeout(() => {
        setIsCoolingDown(false);
        timer.current = null;
      }, durationMS);
    },
    isCoolingDown,
  };
}
export default useCoolDown;
